// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actions } from '../../duck';
import RecoverUserModal from '../components/RecoverUserModal/RecoverUserModal';

import type { RootState } from '../../../../index';

function mapStateToProps(state: RootState) {
  return {
    isRecoveringUser: state.authModals.isRecoveringUser,
    recoverUserError: state.authModals.recoverUserError,
    recoverUserSuccess: state.authModals.recoverUserSuccess,
    forgotPasswordToken: state.authModals.forgotPasswordToken,
    changePasswordModalVisible: state.authModals.changePasswordModalVisible,
  }
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(RecoverUserModal);



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/forgot-password-modal/container/RecoverUserModalContainer.js